import { createFileRoute } from '@tanstack/react-router'
import { BrandPlaybookPage } from '@/features/account/pages/brands/brand-playbook-page'

/** Canonical released-playbook list/detail and metadata editing surface. */
export const Route = createFileRoute('/_ws/w/$workspaceId/brands/$brandId/playbook')({
  component: BrandPlaybookPage,
})
